import React from "react"

function AddTagSVG(props) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g id="tag">
				<path
					id="Vector"
					d="M17.842 9.64984L10.342 2.14984C10.0337 1.8415 9.60866 1.6665 9.16699 1.6665H3.33366C2.89163 1.6665 2.46771 1.8421 2.15515 2.15466C1.84259 2.46722 1.66699 2.89114 1.66699 3.33317V9.1665C1.66699 9.60817 1.84199 10.0332 2.15866 10.3415L2.50033 10.6748C3.25033 10.2248 4.11699 9.99984 5.00033 9.99984C6.32641 9.99984 7.59818 10.5266 8.53586 11.4643C9.47354 12.402 10.0003 13.6738 10.0003 14.9998C10.0003 15.8832 9.76699 16.7415 9.31699 17.4998L9.65033 17.8332C9.95866 18.1498 10.392 18.3332 10.8337 18.3332C11.2753 18.3332 11.7003 18.1582 12.0087 17.8415L17.842 12.0082C18.1587 11.6998 18.3337 11.2748 18.3337 10.8332C18.3337 10.3915 18.1587 9.9665 17.842 9.64984ZM4.58366 5.83317C4.25214 5.83317 3.9342 5.70147 3.69978 5.46705C3.46535 5.23263 3.33366 4.91469 3.33366 4.58317C3.33366 4.25165 3.46535 3.93371 3.69978 3.69929C3.9342 3.46487 4.25214 3.33317 4.58366 3.33317C4.91518 3.33317 5.23312 3.46487 5.46754 3.69929C5.70196 3.93371 5.83366 4.25165 5.83366 4.58317C5.83366 4.91469 5.70196 5.23263 5.46754 5.46705C5.23312 5.70147 4.91518 5.83317 4.58366 5.83317ZM8.33366 15.8332H5.83366V18.3332H4.16699V15.8332H1.66699V14.1665H4.16699V11.6665H5.83366V14.1665H8.33366V15.8332Z"
					fill="#3476E4"
				/>
			</g>
		</svg>
	)
}

export default AddTagSVG
